module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1142.d43e735b.png";